<template>
  <div class="fixed z-20 bottom-[3rem] max-[1024px]:max-w-[20.9375rem] left-1/2 -translate-x-1/2 rounded-lg bg-white shadow-md p-1 flex gap-1 select-none">
    <div class="flex max-[1024px]:overflow-x-auto custom-scrollbar gap-1 m-0 p-0 min-w-0 min-h-0">
      <button
        v-for="section in sections"
        :key="section.elId"
        class="flex-1 relative h-[2.75rem] border-b-2 border-[transparent] rounded-md flex items-center justify-center px-4 font-medium text-[0.875rem] leading-[1.0625rem] hover:bg-[#DAE5FF]"
        @click="navigateToSection(section.elId)"
      >
        {{ section.name }}
        <svg
          v-if="section.elId === currentSectionElId"
          width="49"
          height="4"
          viewBox="0 0 49 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="absolute bottom-0 left-1/2 -translate-x-1/2"
        >
          <path d="M0.5 4C0.5 1.79086 2.29086 0 4.5 0H44.5C46.7091 0 48.5 1.79086 48.5 4H0.5Z" fill="#3565FC"/>
        </svg>
      </button>
    </div>
    <button
      data-vue-init="lead-flow" 
      data-props='{ "gtag": "get_quote"}'  
      class="shrink-0 h-[2.75rem] z-30 bg-[#3565FC] text-nowrap text-white rounded-md flex items-center justify-center px-5 max-[1024px]:!p-[unset] max-[1024px]:w-[2.75rem] font-medium text-[1rem] leading-[1.5rem]"
    >
      <span class="max-[1024px]:hidden">Get Started</span>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="min-[1025px]:hidden"
      >
        <path d="M11.41 2.76922C11.76 2.50922 12.23 2.50922 12.59 2.76922C13.81 3.64922 16.5 6.35922 16.5 12.8992C16.5 15.0592 15.72 17.6592 15.14 19.2492C15 19.6392 14.63 19.8992 14.21 19.8992H9.8C9.38 19.8992 9 19.6392 8.86 19.2492C8.28 17.6592 7.5 15.0592 7.5 12.8992C7.5 6.35922 10.19 3.64922 11.41 2.76922ZM14 10.8992C14 9.79922 13.1 8.89922 12 8.89922C10.9 8.89922 10 9.79922 10 10.8992C10 11.9992 10.9 12.8992 12 12.8992C13.1 12.8992 14 11.9992 14 10.8992ZM7.69 20.4192C7.21 19.1892 6.17 16.2492 6.02 13.5492L4.89 14.2992C4.33 14.6792 4 15.2992 4 15.9692V20.4192C4 21.1292 4.71 21.6092 5.37 21.3492L7.69 20.4192ZM20 20.4192V15.9692C20 15.2992 19.67 14.6792 19.11 14.3092L17.98 13.5592C17.83 16.2492 16.78 19.1992 16.31 20.4292L18.63 21.3592C19.29 21.6092 20 21.1292 20 20.4192Z" fill="white"/>
      </svg>
    </button>
  </div>
</template>
<script>
export default {
  name: 'BuyersGuideSectionsNavigator',
  data() {
    return {
      currentSectionElId: 'el-section-intro-header',
      sections: [
        {
          elId: 'el-section-intro-header',
          name: 'Intro'
        },
        {
          elId: 'el-section-preparation-header',
          name: 'Preparation'
        },
        {
          elId: 'el-section-conditions-header',
          name: 'Conditions'
        },
        {
          elId: 'el-section-delivery-header',
          name: 'Delivery'
        }
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const sections = this.sections.map(section => document.getElementById(section.elId))
      const currentSection = sections.find(section => section && (section.getBoundingClientRect().top > 0 && section.getBoundingClientRect().top < window.innerHeight))
      if (currentSection && currentSection.id !== this.currentSectionElId) {
        this.currentSectionElId = currentSection.id
      }
    },
    navigateToSection(elId) {
      const el = document.getElementById(elId)
      if (el) {
        const yOffset = el.getBoundingClientRect().top + window.scrollY - 60
        window.scrollTo({ top: yOffset, behavior: 'smooth' })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #888;
  &:hover {
    scrollbar-color: #555;
  }
  
  &::-webkit-scrollbar {
    height: 4px;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
</style>